import React from 'react';

const website = "https://namesbymeaning.com/";

const styles={
    divStyle:{
        flex: 1
    },
    shareStyle:{
        fontSize: "12px",
        color: "white",
        float: "right",
        marginTop: "4px",
        marginRight: "auto",
        paddingLeft: "none",
    
    },
    buttonStyle:{
        border: '1px solid dodgerblue',
        padding: "0.4em 1.5em",
        width: "130px",
        borderRadius: "5px",
        backgroundColor: "dodgerblue",
        outline: "none",
        color: "white",
        cursor: 'pointer'
     },
}

const Share = (props)=>{
    const { divStyle, shareStyle,buttonStyle } = styles;
    const {currentName } = props;
    return(
        <div style={divStyle} >
               <a
            target="_blank"
            href={
              "https://twitter.com/home/?status=" +
             currentName.name +
              "" +
              "" +
              " has " +
              currentName.likes +
              " likes " +
              "" +
              "and " +
              currentName.views +
              " Views" +
              " " +
              " - " +
              website 
            }
          >
           <p style={buttonStyle}>
        
           SHARE <i className="fa fa-share-alt" aria-hidden="true"  style={shareStyle}/>
           </p>
           </a>
        </div>
    )
}









export default Share;


// WEBPACK FOOTER //
// ./src/components/mainpage/box/share.js